import * as React from "react";
import { ContentSize } from "VSSUI/Callout";
import { Panel } from "VSSUI/Panel";

import { CompleteMergeBase } from "VersionControl/Scripts/Components/PullRequestReview/CompleteMergeBase";
import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";

export class CompleteMergePanel extends CompleteMergeBase {
    public render(): JSX.Element {
        const hasDanger = this._arePolicyBypassControlsVisible && this.state.shouldBypassPolicy && this._isCompleteButtonEnabled;
        return this.props.isOpen &&
            <Panel
                className="vc-complete-merge-container"
                size={ContentSize.Medium}
                onDismiss={this._onCancel}
                titleProps={{
                    text: this.props.autoComplete ? VCResources.PullRequest_AutoCompleteMergeDialog_Title : VCResources.PullRequest_CompleteMergeDialog_Title,
                }}
                footerButtonProps={[
                    {
                        primary: !hasDanger,
                        text: this._completeButtonText,
                        onClick: () => this._onSave(),
                        disabled: !this._isCompleteButtonEnabled,
                        danger: hasDanger,
                    },
                    {
                        text: VCResources.PullRequest_CompleteMergeDialog_CancelText,
                        onClick: this._onCancel,
                    }
                ]}
            >
                {this._renderMainContent()}
            </Panel>;
    }
}
